module.exports = __webpack_public_path__ + "img/none-module.ea4cf499.svg";